// @ts-nocheck
import getImageSize from "@toolkit/Framework/Common/Utilities/getImageSize";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* Store Custom Code - Start */
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

const design: Styleguide["design"] = {
    product: {
        image: {
            small: getImageSize(210),
            medium: getImageSize(768),
            large: getImageSize(1200),
        },
    },
    category: {
        image: {
            small: getImageSize(768),
        },
    },
    /* Store Custom Code - Start */
    button: {
        field: {
            enabled: false,
        },
    },
    typography: {
        fontFamily: {
            title: `"Montserrat", Arial, Helvetica, sans-serif`,
            base: `"Inter", Arial, Helvetica, sans-serif`,
        },
    },
    header: {
        padding: pxToRemArray([20]),
    },
    menu: {
        secondaryNavigation: {
            height: pxToRemArray([33]),
        },
    },
    /* Store Custom Code - End */
};

export default design;
